import { ThreadErrorIcon } from "../../icons";

export const Error = () => {
  return (
    <div className="tw-mt-32 tw-flex tw-flex-col tw-items-center tw-text-center">
      <div className="tw-flex tw-w-[166px] tw-items-center tw-justify-center">
        <ThreadErrorIcon />
      </div>
      <h2 className="tw-mb-1 tw-mt-4 tw-font-sans tw-text-lg tw-font-bold">
        Oops, something <br /> went wrong
      </h2>
      <p className="tw-m-0 tw-font-sans tw-text-[13px] tw-font-normal">
        Please{" "}
        <span
          className="tw-cursor-pointer tw-text-primary-base tw-transition-colors tw-duration-150 hover:tw-text-primary-500"
          onClick={() => window.location.reload()}
        >
          refresh the page
        </span>{" "}
        to try again.
      </p>
    </div>
  );
};
